{
  "actions": {
    "title": "Nouveaux produits",
    "devices": "Nouveaux équipements",
    "applications": "Nouveaux applicatifs"
  },
  "services": {
    "title": "Activation des services",
    "activeDirectory": "Active Directory",
    "pkiConnector": "Connecteur PKI",
    "smtpServer": "Serveur SMTP",
    "unauthorized": "Aucune information d'activation de service disponible"
  },
  "sector": {
    "title": "Mes secteurs",
    "devices": "Équipements",
    "applications": "Applicatifs"
  },
  "certificates": {
    "valid": "Certificats valides",
    "certificate": "certificats",
    "device": "Certificats S4",
    "manager": "Certificats S4-Manager",
    "tools": "Certificats S4-Tools",
    "view": "Certificats S4-View",
    "legend": {
      "valid": "valide",
      "expireSoon": "validité < 1 mois",
      "expired": "expiré"
    },
    "noData": "Aucune information",
    "title": "État des certificats",
    "expired": "Expiré",
    "lessThanOneMonth": "Inférieur à 1 mois",
    "lessThanThreeMonths": "Inférieur à 3 mois",
    "lessThanSixMonths": "Inférieur à 6 mois",
    "moreThanSixMonths": "Supérieur à 6 mois"
  },
  "firmwares": {
    "noData": "Aucune information",
    "others": "Autres",
    "title": "Distribution des versions de firmware",
    "unknown": "Inconnu"
  },
  "deviceStates": {
    "title": "État des équipements",
    "states": {
      "activated": "Activé",
      "disabled": "Désactivé",
      "preprovisioned": "Pré-provisionné",
      "registered": "Enregistré",
      "locked": "Verrouillé"
    }
  },
  "connectivity": {
    "title": "État de la connectivité",
    "states": {
      "lessThan": "Moins de {duration}",
      "moreThan": "Plus de {duration}",
      "unknown": "Aucune communication"
    },
    "noData": "Aucune information"
  }
}
